import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../../../../assets/icons/zoom.svg'
import _imports_1 from '../../../../assets/icons/upload-icon.svg'
import _imports_2 from '../../../../assets/icons/edit-pen-icon.svg'
import _imports_3 from '@/assets/icons/red-exclaimation.svg'
import _imports_4 from '@/assets/icons/green-star-circle.svg'


const _hoisted_1 = { class: "tw-w-full tw-h-full tw-flex tw-flex-col" }
const _hoisted_2 = { class: "tw-h-[160px] rmd:tw-h-[133px] tw-w-full tw-relative tw-p-4 tw-box-border tw-flex tw-flex-col tw-justify-between tw-items-start tw-overflow-hidden" }
const _hoisted_3 = { class: "tw-w-full tw-h-full tw-absolute tw-z-0 tw-left-0 tw-top-0 tw-overflow-hidden" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "tw-flex tw-justify-between tw-items-center tw-w-full tw-max-w-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "tw-w-full tw-flex tw-items-center tw-gap-2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-[16px] tw-h-[16px] tw-rounded-full tw-bg-[#FFA500] tw-flex tw-items-center tw-justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "edit_icon tw-w-[8px] tw-h-[8px]",
    style: {"filter":"invert(93%) sepia(93%) saturate(0%)\n                        hue-rotate(265deg) brightness(105%) contrast(108%)"}
  })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "tw-inline-block tw-w-[calc(100%-30px)] tw-text-left tw-whitespace-nowrap" }, " Upload Image ", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "tw-w-full tw-flex tw-items-center tw-gap-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "tw-w-[16px] tw-h-[16px] tw-rounded-full tw-bg-[#4A92E5] tw-flex tw-items-center tw-justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "edit_icon tw-w-[8px] tw-h-[8px]",
    style: {"filter":"invert(93%) sepia(93%) saturate(0%)\n                        hue-rotate(265deg) brightness(105%) contrast(108%)"}
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "tw-inline-block tw-w-[calc(100%-30px)] tw-text-left tw-whitespace-nowrap" }, " Edit Image ", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "free_workstation_box tw-flex tw-items-center tw-gap-1 tw-px-2 tw-py-1 tw-rounded-lg"
}
const _hoisted_16 = {
  key: 0,
  src: _imports_3,
  class: "md:tw-min-w-[10px] md:tw-max-w-[10px] md:tw-min-h-[10px] md:tw-max-h-[10px]"
}
const _hoisted_17 = {
  key: 1,
  class: "tw-flex tw-items-center tw-gap-1"
}
const _hoisted_18 = { class: "free_workstation_box tw-flex tw-items-center tw-gap-1 tw-px-2 tw-py-1 tw-rounded-lg" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_20 = { class: "tw-text-[10px] rmd:tw-text-xs tw-font-bold tw-leading-6 tw-text-[#24BD63] tw-tracking-wide" }
const _hoisted_21 = { class: "tw-flex tw-flex-col tw-justify-between tw-items-start tw-p-3 tw-box-border" }

import { LatLngExpression } from "leaflet";
import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";

import Card from "@/core/components/ui/general/Card.vue";
import ChipState from "@/core/components/common/ChipState.vue";
import Text from "@/core/components/ui/general/Text.vue";
import LeafletMap from "@/core/components/map/LeafletMap.vue";
import { PROPERTY_STORE } from "@/store/modules/property";
import { WORKSTATION } from "@/store/modules/workstation";
import { UserVerificationStatusEnum } from "@/core/enums/RolesEnum";
import { parseJSON } from "@/core/utils/common";
import { UserWorkstationSubStatusEnum } from "@/core/enums";
import PropertyImageModal from "../Modals/PropertyImageModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PropertyCard',
  props: {
  hasOpenMapButtonInMobile: {
    type: Boolean,
    default: false,
  },
},
  emits: ["on-map-full-screen"],
  setup(__props, { emit: __emit }) {

const store = useStore();

const emits = __emit;
const props = __props;

const isUpdateImage = ref(false);
const propertyDetails = computed(
  () => store.getters[`${PROPERTY_STORE}/propertyDetails`]
);

const getLatLng = (addressData: string): LatLngExpression | undefined => {
  if (!addressData) return undefined;

  try {
    const unParsedData = parseJSON(addressData);
    const latlng: LatLngExpression = [
      unParsedData.LAT ? unParsedData.LAT : unParsedData.lat,
      unParsedData.LNG ? unParsedData.LNG : unParsedData.lng,
    ];
    return latlng;
  } catch (error) {
    console.error("Invalid address data:", error);
    return undefined;
  }
};

const userWorkStationStatus = computed(
  () =>
    store.getters[`${WORKSTATION}/activeUserWorkstation`]?.verificationStatus
);

const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const userWorkstationStatusByWord = computed(() => {
  if (userWorkStationStatus.value === UserVerificationStatusEnum.NOT_ADDED) {
    return null;
  }
  if (userWorkStationStatus.value === UserVerificationStatusEnum.VERIFIED) {
    return "VERIFIED";
  }
  if (
    userWorkStationStatus.value ===
    UserVerificationStatusEnum.PENDING_VERIFICATION
  ) {
    return "UNVERIFIED";
  }
  return "";
});

const onFullScreenRequest = () => {
  emits("on-map-full-screen");
};

const toggleUpdateImages = () => {
  isUpdateImage.value = !isUpdateImage.value;
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(Card, { class: "!tw-h-[204px] !tw-min-h-[204px] rmd:!tw-h-[198px] rmd:!tw-min-h-[198px] tw-overflow-hidden" }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!propertyDetails.value?.localData?.propertyImage)
              ? (_openBlock(), _createBlock(LeafletMap, {
                  key: 0,
                  defaultViewZoom: 17,
                  isDraggable: false,
                  showControls: false,
                  data: [],
                  latlang: getLatLng(propertyDetails.value?.localData?.addressData)
                }, null, 8, ["latlang"]))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "tw-w-full tw-h-full",
                  src: propertyDetails.value?.localData?.publicUrl
                }, null, 8, _hoisted_4))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ChipState, {
              class: "tw-relative tw-z-10",
              bgColor: "#0C0F4A",
              label: propertyDetails.value?.localData?.postcode,
              textColor: "#FFF"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  class: "!tw-text-[14px]",
                  icon: "mdi-map-marker",
                  color: "#FFF"
                })
              ]),
              _: 1
            }, 8, ["label"]),
            (__props.hasOpenMapButtonInMobile)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: onFullScreenRequest,
                  class: "tw-flex tw-cursor-pointer tw-rounded-[6px] tw-bg-white tw-p-[.4rem] tw-box-border tw-w-auto tw-h-[36px] tw-items-center tw-justify-center tw-gap-2 tw-z-10 rmd:!tw-hidden"
                }, [
                  _createVNode(Text, {
                    variant: "p",
                    textWeight: "400",
                    whiteSpace: "nowrap"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Open Map ")
                    ]),
                    _: 1
                  }),
                  _hoisted_6
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              onClick: toggleUpdateImages,
              class: _normalizeClass(["tw-cursor-pointer tw-px-[10px] tw-py-[4px] tw-rounded-md tw-bg-white tw-w-[130px] tw-flex tw-items-center tw-text-xs tw-gap-1 tw-font-normal tw-z-10 tw-text-[#0C0F4A80] tw-leading-[13.99px]", { 'md:!tw-hidden': __props.hasOpenMapButtonInMobile }])
            }, [
              (!propertyDetails.value?.localData?.propertyImage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
            ], 2)
          ]),
          _createVNode(ChipState, {
            class: "tw-relative tw-z-10",
            hasCustomLabel: true,
            bgColor: "#FFF",
            hasShadow: true
          }, {
            "custom-label": _withCtx(() => [
              (
                  activeUserWorkstation.value?.subscription &&
                  activeUserWorkstation.value.value?.subStatus ===
                    _unref(UserWorkstationSubStatusEnum).SUCCEEDED
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (userWorkstationStatusByWord.value === 'UNVERIFIED')
                      ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                      : _createCommentVNode("", true),
                    (userWorkstationStatusByWord.value === 'VERIFIED')
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          icon: "mdi-shield-check",
                          color: "#FFA500",
                          class: "md:!tw-text-[10px]"
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass(["tw-text-[10px] rmd:tw-text-xs tw-font-bold tw-leading-6 tw-tracking-wide", [
                    userWorkstationStatusByWord.value === 'UNVERIFIED'
                      ? 'tw-text-[#FA4B00]'
                      : 'tw-text-[#24BD63]',
                  ]])
                    }, _toDisplayString(userWorkstationStatusByWord.value), 3),
                    _createVNode(Text, {
                      variant: "xsmall",
                      class: "rmd:!tw-text-[12px]",
                      whiteSpace: "nowrap",
                      textColor: "#FFA500"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(propertyDetails.value?.localData?.propertyType) + " PROPERTY OWNER", 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (
                  userWorkStationStatus.value ===
                    _unref(UserVerificationStatusEnum).NOT_ADDED &&
                  (!activeUserWorkstation.value?.subscription ||
                    activeUserWorkstation.value.value?.subStatus !==
                      _unref(UserWorkstationSubStatusEnum).SUCCEEDED)
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("span", _hoisted_20, _toDisplayString(propertyDetails.value?.localData?.userWorkstation.subscription
                        ? "PAID WORKSTATION"
                        : "FREE WORKSTATION"), 1),
                      _createVNode(Text, {
                        variant: "xsmall",
                        class: "rmd:!tw-text-[12px]",
                        whiteSpace: "nowrap",
                        textColor: "#FFA500"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" PROPERTY OWNER")
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(Text, {
            variant: "p",
            class: "rmd:!tw-text-[18px] rmd:!tw-leading-6",
            textWeight: "600",
            textAlign: "left",
            lineHeight: "18px"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(propertyDetails.value?.localData?.address), 1)
            ]),
            _: 1
          }),
          _createVNode(Text, {
            class: "!tw-text-[11px]",
            textWeight: "600"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Property ID: " + _toDisplayString(propertyDetails.value?.localData?.id), 1)
            ]),
            _: 1
          })
        ]),
        (isUpdateImage.value)
          ? (_openBlock(), _createBlock(PropertyImageModal, {
              key: 0,
              onOnClose: toggleUpdateImages,
              isGallery: false,
              forDocuments: false,
              isPropertyDocument: false
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})